const SPRINT16_QA_HOST = 'sprint16-staging-preparation.obelanse.pages.dev'
const CART_STORAGE_KEY = 'obelanse:v1:cart'

function cartItemCount(): number {
  try {
    const parsed = JSON.parse(window.localStorage.getItem(CART_STORAGE_KEY) ?? 'null') as unknown
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return 0
    const lines = (parsed as { lines?: unknown }).lines
    if (!Array.isArray(lines)) return 0
    return lines.reduce((total, value) => {
      if (!value || typeof value !== 'object' || Array.isArray(value)) return total
      const quantity = Number((value as { quantity?: unknown }).quantity)
      return Number.isSafeInteger(quantity) && quantity > 0 ? total + quantity : total
    }, 0)
  } catch {
    return 0
  }
}

function enableQaFigmaReview(): void {
  if (window.location.hostname.toLowerCase() !== SPRINT16_QA_HOST) return

  const root = document.documentElement
  root.classList.add('qa-figma-review')

  const syncCartState = () => {
    root.classList.toggle('qa-has-cart', cartItemCount() > 0)
  }

  syncCartState()
  window.addEventListener('obelanse:cart', syncCartState)
  window.addEventListener('storage', syncCartState)
}

enableQaFigmaReview()
